/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

import { VNode, ComponentChildren } from 'preact';
import { classes } from '.';

export type VComponentProps = {
  node: VNode | VNode[];
  children?: ComponentChildren;
  [key: string]: any; // allow other unspecified props to be passed without any TS warning
};

export function VComponent({ node, ...props }: VComponentProps) {
  if (!node) return null;

  if (Array.isArray(node)) {
    return (
      <>
        {node.map((n, key) => (
          <VComponent
            key={key}
            node={n}
            className={props.className}
            {...props}
          />
        ))}
      </>
    );
  }

  // @ts-ignore
  props.className = classes([node.props.className, props.className]);

  // @ts-ignore
  return <node.type ref={node.ref} key={node.key} {...node.props} {...props} />;
}
